angular.module("leanlaw.core").factory("chargeManager", ["$q", "leanLawApi", 'lists', function ($q, leanLawApi, lists) {
  var _services = {
    create: create,
    createStandard: createStandard,
    listForMatter: listForMatter,
    listForClient: listForClient,
    listStandard: listStandard,
    addStandardToMatter: addStandardToMatter,
    get: get
  };

  /////////////////////////////

  var Charge = function () {};
  Charge.prototype.load = function (c) {
    angular.copy(c, this);
    if (c.date) {
      this.date = new Date(c.date);
    }
    if (c.endDate) {
      this.endDate = new Date(c.endDate);
    }
    if (this.recurrence) {
      this.recurrence.label = lists.recurringPeriodFromId(this.recurrence.period);
    }
    this.$original = c;
    return this;
  };
  Charge.prototype.undo = function (c) {
    this.load(this.$original);
    return this;
  };
  Charge.prototype.update = function (update) {
    var c = this;
    return leanLawApi.updateCharge({
      id: c.id,
      body: update || c
    }).then(function (c) {
      return new Charge().load(c);
    });
  };
  Charge.prototype.delete = function () {
    var c = this;
    return leanLawApi.deleteCharge({
      id: c.id
    });
  };
  function listForMatter(matterId, request) {
    if (!request) request = {};
    var copy = angular.copy(request);
    copy.matterId = matterId;
    return leanLawApi.listCharges(copy).then(processChargesList);
  }
  function listForClient(clientId, request) {
    if (!request) request = {};
    var copy = angular.copy(request);
    copy.clientId = clientId;
    return leanLawApi.listCharges(copy).then(processChargesList);
  }
  function listStandard() {
    return leanLawApi.listStandardCharges().then(processChargesList).then(function (charges) {
      var groups = _.groupBy(charges, c => c.group ? c.group.id : null);
      var select = [];
      _.each(groups, function (charges, name) {
        if (name && name != "null") {
          select.push({
            id: name,
            label: name + " (milestone)",
            charges: charges
          });
        }
      });
      if (groups[null]) {
        select = select.concat(groups[null]);
      }
      return {
        select: select,
        groups: groups
      };
    });
  }
  function processChargesList(list) {
    if (!list) return [];
    return list.charges.map(c => {
      return new Charge().load(c);
    });
  }
  function create(matter, create) {
    create.matter = matter;
    return leanLawApi.createCharge({
      body: create
    }).then(c => {
      return new Charge().load(c);
    });
  }
  function createStandard(create) {
    return leanLawApi.createStandardCharge({
      body: create
    }).then(c => {
      return new Charge().load(c);
    });
  }
  function get(id) {
    return leanLawApi.getCharge({
      id
    }).then(c => {
      return new Charge().load(c);
    });
  }
  function addStandardToMatter(matter, standard) {
    if (standard.charges) {
      // milestone
      var created = _.map(standard.charges, c => create(matter, c));
      return $q.all(created);
    } else {
      // individual
      return create(matter, standard);
    }
  }
  return _services;
}]);